<template>
    <section>
      <div style="padding-top: 22px" v-if="addOns.tickets">
        <div class="hero is-bold">
          <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div >
              <h1 class="title" style="color:#3e8ed0">Tickets</h1>
              <h5 class="subtitle">Manage your tickets here.</h5>
            </div>
          </div>
        </div>
        <b-table :data="tableData" striped>
          <template slot-scope="props">
            <b-table-column field="dateCreated" label="Date created"  class="topPadding" centered>
              {{formatTimestamp(props.row.timestamp)}}
            </b-table-column>
            <b-table-column field="title" label="Title"  class="topPadding" centered>
              {{props.row.title}}
            </b-table-column>
            <b-table-column field="description" label="Description"  class="topPadding" centered>
              {{props.row.desc}}
            </b-table-column>
            <b-table-column field="priority" label="Priority"  class="topPadding" centered>
              {{priorities[props.row.priority]}}
            </b-table-column>
            <b-table-column field="email" label="Email"  class="topPadding" centered>
              {{props.row.email}}
            </b-table-column>
            <b-table-column field="phoneNumber" label="Phone number"  class="topPadding" centered>
              {{props.row.phoneNumber}}
            </b-table-column>
            <b-table-column field="status" label="Status"  class="topPadding" centered>
              {{statuses[props.row.status]}}
            </b-table-column>
            <b-table-column field="response" label="Response"  class="topPadding" centered>
              {{props.row.response}}
            </b-table-column>
            <b-table-column field="delete" label="Delete"  class="topPadding" centered>
              <b-button :disabled="role === 'viewer'" icon-left="trash" @click="deleteTicketDialog(props.index)" class="button is-danger is-small">
                </b-button>
            </b-table-column>
          </template>
        </b-table>
      </div>
      <vue-fab v-if="!bAddTicket" title="Create ticket" :scrollAutoHide="autoHide" mainBtnColor="#48c78e" icon="add" size="big" @clickMainBtn="addTicketModal" :hidden="role === 'viewer' || !addOns.tickets"/>
    </section>
  </template>

<script>
import AddTicket from './AddTicket.vue'

export default {
  name: 'Tickets',
  data: () => {
    return {
      tableData: [],
      autoHide: false,
      loadingComponent: null,
      bAddTicket: false,
      priorities: {
        low: 'Low',
        mid: 'Medium',
        high: 'High'
      },
      statuses: {
        unresolved: 'Unresolved',
        resolved: 'Resolved'
      }
    }
  },
  computed: {
    tickets () {
      return this.$store.state.tickets
    },
    role () {
      return this.$store.state.role
    },
    addOns () {
      return this.$store.state.addOns
    }
  },
  watch: {
    tickets () {
      this.tableData = []
      for (let tckt in this.tickets) {
        this.tableData.push({ id: tckt, ...this.tickets[tckt] })
      }
    }
  },
  mounted: function () {
    if (this.tickets) {
      for (let tckt in this.tickets) {
        this.tableData.push({ id: tckt, ...this.tickets[tckt] })
      }
    }
  },
  methods: {
    addTicketModal () {
      if (this.role !== 'viewer') {
        this.bAddTicket = true
        this.$buefy.modal.open({
          parent: this,
          component: AddTicket,
          props: { propParentFn: this.cancelAdd },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    },
    deleteTicketDialog (id) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure that you want to delete ticket "' + this.tableData[id].title + '"?',
        cancelText: 'No',
        confirmText: 'Yes',
        type: 'is-danger',
        onConfirm: () => {
          this.deleteTicket(id)
        }
      })
    },
    deleteTicket (id) {
      this.loadingComponent = this.$buefy.loading.open()

      let ticketId = this.tableData[id].id

      this.$store.state.database.ref('/neoslide/tickets/' + this.$store.state.workspaceId + '/' + ticketId).remove()
        .then(() => {
          this.loadingComponent.close()
        })
        .catch(error => {
          this.loadingComponent.close()
          this.globalLogger('could not remove ticket', error)
          this.showAlert()
        })
    },
    showAlert () {
      this.$buefy.dialog.alert({
        title: 'Operation faild',
        message: 'Deleting ticket failed. Please try again.',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    cancelAdd () {
      this.bAddTicket = false
    },
    formatTimestamp (timestamp) {
      return new Date(timestamp).toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // 24-hour format
      })
    }
  }
}
</script>
<style scoped>
.topPadding {
  padding-top: 14px
}
</style>



// WEBPACK FOOTER //
// src/components/tickets/Tickets.vue